module.exports = __webpack_public_path__ + "img/BANVIET.12967f16.svg";